<div
  class="container-fluid m-0 p-5 block"
  [ngClass]="{ 'theme-darkk': themeService.flag }"
>
  <div class="text-center">
    <h2 class="font-pacifico">
      <span
        class="text-underline cursor-pointer"
        (click)="navigate('\experience')"
        >Work Experience</span
      >.
    </h2>
  </div>
  <p class="tagline font-raleway">
    I am currently working as a
    <strong
      >Software Development Engineer 1 at
      <a href="https://blinkit.com/" target="_blank" rel="noopener noreferrer"
        >Blinkit</a
      ></strong
    >, and a Freelance Developer.
  </p>
  <p class="tagline font-oxygen">
    Here's a 3D demonstration of my Work Experience, demonstrating the companies
    I've worked with as planets arranged in ascending order, revolving around
    the sun:
  </p>

  <div class="d-flex justify-content-center">
    <button
      type="button"
      class="btn mybtn depth m-3 mt-4"
      [ngClass]="{ 'mybtn-dark': themeService.flag }"
      (click)="load()"
    >
      <fa-icon [icon]="faRedoAlt"></fa-icon>
      <span class="h5 ml-2">Load 3D</span>
    </button>
  </div>

  <iframe
    id="threed"
    *ngIf="display"
    src="https://experience.tanaytoshniwal.me/"
    frameborder="0"
    width="100%"
    height="100%"
    style="min-height: 540px"
  ></iframe>

  <div class="d-flex justify-content-center">
    <button
      type="button"
      class="btn mybtn depth m-3 mt-4"
      [ngClass]="{ 'mybtn-dark': themeService.flag }"
      (click)="navigate('\experience')"
    >
      <fa-icon [icon]="faInfoCircle"></fa-icon>
      <span class="h5 ml-2">Know More...</span>
    </button>
  </div>
</div>
